export const getTimeLeftLabel = (recovery) => {
  if (!recovery) return "";
  if (recovery.daysLeft >= 2) return `${recovery.daysLeft} days left`;
  if (recovery.daysLeft === 1) return "Ends tomorrow night";

  const msLeft = new Date(recovery.expiresAt).getTime() - Date.now();
  const hoursLeft = Math.max(0, Math.floor(msLeft / (60 * 60 * 1000)));
  if (hoursLeft >= 1) return `Last day! ${hoursLeft}h left`;
  return "Last day! Minutes left";
};

export const getLessonsLeft = (recovery) =>
  recovery ? Math.max(0, recovery.lessonsRequired - recovery.lessonsCompleted) : 0;

const SEEN_KEY = "streakFrozenModalSeen";

// The frozen modal opens on its own once per day per freeze
export const shouldAutoShowFrozenModal = (recovery) => {
  if (!recovery) return false;
  const today = new Date().toLocaleDateString("en-CA");
  return localStorage.getItem(SEEN_KEY) !== `${recovery.expiresOn}:${today}`;
};

export const markFrozenModalSeen = (recovery) => {
  if (!recovery) return;
  const today = new Date().toLocaleDateString("en-CA");
  localStorage.setItem(SEEN_KEY, `${recovery.expiresOn}:${today}`);
};
